<script>
  import { _ } from 'svelte-i18n'
  import Insert from '../../elements/Insert.svelte'
  import Button from '../../elements/Button.svelte'

  export let insert_position
  const insert_no = Math.floor(Math.random()*3)

</script>

{#if insert_position === 'filtered_previews'}
  {#if insert_no === 0}
    <Insert {insert_position}>
      <span slot="toptitle">
        { $_('inserts.export.topTitle')}
      </span>
      <span slot="title">
        Do you need save these for later?<br>
      </span>
      <span slot="text">
        You can download these previews as an image.
        <small>
          { $_('inserts.export.instructions')}
        </small>
      </span>
      <span slot="button">
        <Button kind="outline" href="/help/exporting-an-image/" target="_blank"> ↗︎ { $_('buttons.learnMore')}</Button>
      </span>
    </Insert>
  {:else if insert_no === 1}
    <Insert {insert_position}>
      <span slot="toptitle">
        { $_('inserts.export.topTitle')}
      </span>
      <span slot="title">
        Do you need someone else to look at these?<br>
      </span>
      <span slot="text">
        You can download these previews as an image and share to get feedback.
        <small>
          { $_('inserts.export.instructions')}
        </small>
      </span>
      <span slot="button">
        <Button kind="outline" href="/help/exporting-an-image/" target="_blank"> ↗︎ { $_('buttons.learnMore')}</Button>
      </span>
    </Insert>
  {:else if insert_no === 2}
    <Insert {insert_position}>
      <span slot="toptitle">
        { $_('inserts.export.topTitle')}
      </span>
      <span slot="title">
        Going to cut these with Cricut?<br>
      </span>
      <span slot="text">
        You can export them as ready-to-cut transparent images and import into Cricut Design Studio or Silhouette Studio.
        <small>
          Hover over any of the fonts above, click + (Details) and click Export on top left.
        </small>
      </span>
      <span slot="button">
        <Button kind="outline" href="/help/export-to-cricut/" target="_blank"> ↗︎ { $_('buttons.learnMore')}</Button>
      </span>
    </Insert>
  {/if}
{/if}